import { pollResultsPublished } from './publication.js'

export function pollIdentifier(poll) { return String(poll?.id || poll?.pollId || '') }

export function emptyActivePoll() {
  return { id: '', title: '', status: 'closed', kind: 'SingleChoice', options: [], resultsVisible: false,
    resultsAvailable: false, responded: false, selectedOptionIds: [], responseText: '', wordCloud: [], totalResponses: 0 }
}

export function upsertLibraryPoll(state, source, results = null, revision = 0) {
  const id = pollIdentifier(source)
  if (!id || !Array.isArray(source?.options)) return null
  state.pollLibrary ||= []
  const index = state.pollLibrary.findIndex(poll => poll.id === id)
  const previous = index >= 0 ? state.pollLibrary[index] : null
  const incoming = Number(source.revision ?? revision) || 0
  if (previous && incoming < (Number(previous.revision) || 0)) {
    if (results) applyLibraryResults(state, id, results, revision)
    return previous
  }
  const poll = {
    ...previous, id, title: String(source.title ?? source.prompt ?? ''),
    kind: source.kind || (source.multiple ? 'MultipleChoice' : 'SingleChoice'),
    status: source.status || (source.isOpen ? 'open' : 'closed'),
    isActive: typeof source.isActive === 'boolean' ? source.isActive : (previous?.isActive ?? (source.isOpen === true || source.status === 'open')),
    resultsVisible: pollResultsPublished(source),
    options: source.options.map(option => ({ id: String(option.id || option.optionId), label: String(option.label || ''), votes: Number(option.votes ?? previous?.options?.find(old => old.id === (option.id || option.optionId))?.votes ?? 0) })),
    revision: incoming,
    totalResponses: Number(previous?.totalResponses || 0),
    resultsRevision: Number(previous?.resultsRevision || 0),
    wordCloud: previous?.wordCloud || [],
  }
  if (index < 0) state.pollLibrary.push(poll)
  else state.pollLibrary[index] = poll
  if (results) applyLibraryResults(state, id, results, revision)
  return state.pollLibrary.find(candidate => candidate.id === id)
}

export function applyLibraryResults(state, id, results, revision = 0) {
  const poll = state.pollLibrary?.find(candidate => candidate.id === id)
  if (!poll || !results || typeof results.counts !== 'object') return false
  const incoming = Number(results.revision ?? revision) || 0
  if (incoming < (Number(poll.resultsRevision) || 0)) return true
  poll.totalResponses = Math.max(0, Number(results.responseCount) || 0)
  poll.wordCloud = Array.isArray(results.wordCloud) ? results.wordCloud : []
  poll.options.forEach(option => { option.votes = Math.max(0, Number(results.counts[option.id]) || 0) })
  poll.resultsRevision = incoming
  return true
}

export function applyLibrarySnapshot(state, definitions, results = {}, revision = 0) {
  const ids = new Set(definitions.map(pollIdentifier))
  state.pollLibrary ||= []
  state.pollLibrary = state.pollLibrary.filter(poll => ids.has(poll.id) || Number(poll.revision) > Number(revision))
  for (const definition of definitions) upsertLibraryPoll(state, definition, results[pollIdentifier(definition)], revision)
  state.pollLibraryLoaded = true
}
